module.exports = __webpack_public_path__ + "static/media/semiconducts.fe1c8e32.jpg";